import React, { useEffect, useState } from 'react'
import ContactForm from '../../components/contact/contactform.components'
import { useOrder } from '../../hooks/useAuth'
import GalleryItems from '../gallery/gallery-items.components'
import './gallery.styles.scss'

const GalleryPage = () => {
  const { curPage } = useOrder()
  const [page, setPage] = useState(curPage)

  useEffect(() => {
    setPage(curPage)
  }, [curPage])

  return (
    <>
      <section className="gallery-v2">
        <div className="gallery-v2__glow gallery-v2__glow--a" aria-hidden="true" />
        <div className="gallery-v2__glow gallery-v2__glow--b" aria-hidden="true" />

        <div className="gallery-v2__inner">
          <div className="gallery-v2__intro">
            <p className="gallery-v2__eyebrow">From the kitchen</p>
            <h1>
              <span className="gallery-v2__script">Our</span>
              <span className="gallery-v2__solid">gallery</span>
            </h1>
            <p className="gallery-v2__lead">
              Browse recent bakes and custom designs. Tap a photo for a closer look.
            </p>
          </div>

          <GalleryItems />
        </div>
      </section>

      <ContactForm company={page?.company || {}} />
    </>
  )
}

export default GalleryPage
